// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { ArrayUtils } from '@shared/utils/ArrayUtils';
import { Message } from '@shared/utils/DirectMessages/DirectMessagesImport';
import { Connection } from '../Connection';
import { Algorithm, AlgorithmSubscribeType } from './Algorithm/Algorithm';
export class AlgorithmCache {
    constructor(dCache) {
        this.algorithmsAvailableByID = {};
        this.algorithmsAvailableByType = {};
        this.algorithmSubscribersByAlgorithmId = {};
        this.algorithmMessagesCacheByAlgorithmId = {};
        this.DCache = dCache;
    }
    SubscriptionHandler(subscribe, algorithmID, subscriber) {
        let NeedProc = false;
        if (subscribe === AlgorithmSubscribeType.Subscribe) {
            let subscribers = this.algorithmSubscribersByAlgorithmId[algorithmID];
            if (!subscribers) {
                subscribers = [];
            }
            NeedProc = !subscribers.length;
            subscribers.push(subscriber);
            this.algorithmSubscribersByAlgorithmId[algorithmID] = subscribers;
            const msg = this.algorithmMessagesCacheByAlgorithmId[algorithmID];
            if (msg) {
                subscriber.ProcessAlgorithm(msg);
            }
        }
        else {
            const subscribers = this.algorithmSubscribersByAlgorithmId[algorithmID];
            if (subscribers) {
                ArrayUtils.RemoveElementFromArray(subscribers, subscriber);
                NeedProc = !subscribers.length;
            }
        }
        if (NeedProc) {
            Connection.vendor.AlgorithmSubscribeMessage(subscribe, algorithmID);
        }
    }
    NewMessage(msg) {
        switch (msg.Code) {
            case Message.CODE_PFIX_ALGORITHMS_AVAILABLE_MESSAGE:
                this.ProcessAlgorithmsAvailableMessage(msg);
                break;
            case Message.CODE_PFIX_ALGORITHM_SUBSCRIBE_MESSAGE:
                // TODO Subscribe/Unsubscibe result from server
                break;
            case Message.CODE_PFIX_ALGORITHM_GAINERS_LOSERS_MESSAGE:
            case Message.CODE_PFIX_ALGORITHM_HIGH_LOW_MESSAGE:
            case Message.CODE_PFIX_ALGORITHM_TOP_VOLUME_MESSAGE:
            case Message.CODE_PFIX_ALGORITHM_HISTORICAL_GAINER_LOSER_TOPS_MESSAGE:
            case Message.CODE_PFIX_ALGORITHM_HEATMAP_MESSAGE:
                this.ProcessAlgorithmMessage(msg);
                break;
        }
    }
    ProcessAlgorithmsAvailableMessage(msg) {
        if (!msg) {
            return;
        }
        const myAlgorithm = this.getAlgorithmByAlgorithmId(msg.AlgorithmId); // search in created
        if (myAlgorithm) // if already exist
         {
            myAlgorithm.UpdateByMessage(msg);
        } // update algorithm
        else // if have not exist yet
         {
            this.addAlgorithmId(new Algorithm(msg));
        } // create new algorithm and add it to AlgorithmCache
        // if (msg.AlgorithmType != 2)
        //     this.SubscriptionHandler(AlgorithmSubscribeType.Subscribe, msg.AlgorithmId, this)
    }
    ProcessAlgorithm(msg) {
        // for test
    }
    ProcessAlgorithmMessage(msg) {
        if (!msg) {
            return;
        }
        const subscribers = this.algorithmSubscribersByAlgorithmId[msg.AlgorithmId];
        if (subscribers) {
            for (let i = 0; i < subscribers.length; i++) {
                subscribers[i].ProcessAlgorithm(msg);
            }
        }
        this.algorithmMessagesCacheByAlgorithmId[msg.AlgorithmId] = msg;
    }
    addAlgorithmId(algorithm) {
        this.algorithmsAvailableByID[algorithm.AlgorithmId] = algorithm;
        const arr = this.getAlgorithmsByAlgorithmType(algorithm.AlgorithmType);
        arr.push(algorithm);
        this.algorithmsAvailableByType[algorithm.AlgorithmType] = arr;
    }
    clear() {
        this.algorithmsAvailableByType = {};
        this.algorithmMessagesCacheByAlgorithmId = {};
        this.algorithmSubscribersByAlgorithmId = {};
        this.algorithmsAvailableByID = {};
    }
    getAlgorithmsByAlgorithmType(algorithmType) {
        return this.algorithmsAvailableByType[algorithmType] || [];
    }
    getAlgorithmByAlgorithmId(algorithmId) {
        return this.algorithmsAvailableByID[algorithmId] || null;
    }
}
